import { jsx as s, jsxs as x, Fragment as C } from "react/jsx-runtime";
import { j as r, k as o, q as I, o as O, T as P, G as T, c5 as E, c6 as w, bc as y, c7 as N, ak as R, aQ as L, a0 as b } from "./helpers-458d7e27.js";
import d from "clsx";
import { useRef as h } from "react";
const v = (n) => {
  const e = n % 4 === 0, l = {
    options: {
      columnStart: n % 2 === 0 ? r.leftInner : r.auto,
      columnSpan: 2
    },
    mdOptions: {
      columnStart: n % 4 === 0 ? r.leftInner : r.auto,
      columnSpan: 1
    },
    lgOptions: {
      columnStart: n % 4 === 0 ? r.leftInner : r.auto,
      columnSpan: 3
    },
    xlOptions: {
      columnStart: e ? r.leftInner : r.auto,
      columnSpan: 12 / 4
    }
  }, a = {
    lgOptions: {
      columnStart: o.inner2,
      columnEnd: o.inner12
    }
  };
  return {
    logos12Col: l,
    logos10Col: a
  };
}, W = () => {
  const n = {
    options: {
      columnStart: r.leftInner,
      columnSpan: 4,
      bottomSpacing: "6vw"
    },
    lgOptions: {
      columnStart: o.inner8,
      columnSpan: 5
    }
  }, t = {
    options: {
      columnStart: r.leftInner,
      columnSpan: 4,
      bottomSpacing: "6vw"
    },
    lgOptions: {
      columnStart: o.inner8,
      columnSpan: 4
    }
  };
  return {
    text12Col: n,
    text10Col: t
  };
}, D = () => {
  const n = {
    options: {
      columnStart: r.leftInner,
      columnSpan: 4,
      bottomSpacing: "6vw"
    },
    lgOptions: {
      columnStart: o.inner3,
      columnSpan: 8
    },
    xlOptions: {
      columnStart: o.inner4,
      columnSpan: 6
    }
  }, t = {
    options: {
      columnStart: r.leftInner,
      columnSpan: 4,
      bottomSpacing: "6vw"
    },
    lgOptions: {
      columnStart: o.inner3,
      columnSpan: 8
    },
    xlOptions: {
      columnStart: o.inner4,
      columnSpan: 6
    }
  };
  return {
    text12Col: n,
    text10Col: t
  };
}, k = () => {
  const n = {
    options: {
      columnStart: r.leftInner,
      columnSpan: 4,
      bottomSpacing: "6vw"
    },
    lgOptions: {
      columnSpan: 7
    },
    xlOptions: {
      columnSpan: 6
    }
  }, t = {
    options: {
      columnStart: r.leftInner,
      columnSpan: 4,
      bottomSpacing: "6vw"
    },
    lgOptions: {
      columnStart: o.inner2,
      columnSpan: 8
    },
    xlOptions: {
      columnSpan: 6
    }
  };
  return {
    text12Col: n,
    text10Col: t
  };
}, B = (n, t) => n ? W() : t === "Center" && !n ? D() : k(), A = (n) => n === "compact", F = (n) => n === "regular", _ = (n, t) => {
  const e = {
    lgOptions: {
      columnStart: n ? o.inner8 : r.leftInner,
      columnEnd: n ? o.inner12 : o.inner8
    },
    xlOptions: {
      columnStart: n ? o.inner8 : r.leftInner,
      columnEnd: n ? o.inner12 : o.mid
    }
  }, l = {
    lgOptions: {
      columnStart: n ? o.inner8 : o.inner2,
      columnEnd: o.inner12
    },
    xlOptions: {
      columnStart: n ? o.inner8 : o.inner2,
      columnEnd: n ? o.inner12 : o.inner8
    }
  };
  return t === "Center" && !n && (l.mdOptions = {
    columnStart: o.inner2,
    columnEnd: o.inner4
  }, l.lgOptions = {
    columnStart: o.inner4,
    columnEnd: o.inner10
  }, l.xlOptions = {
    columnStart: o.inner5,
    columnEnd: o.inner10
  }, l.twoXlOptions = {
    columnStart: o.inner4,
    columnEnd: o.inner10
  }, e.mdOptions = {
    columnStart: o.inner2,
    columnEnd: o.inner4
  }, e.lgOptions = {
    columnStart: o.inner4,
    columnEnd: o.inner10
  }, e.xlOptions = {
    columnStart: o.inner5,
    columnEnd: o.inner10
  }, e.twoXlOptions = {
    columnStart: o.inner4,
    columnEnd: o.inner10
  }), {
    text12Col: e,
    text10Col: l
  };
}, J = (n, t, e) => F(e) ? _(n, t) : B(n, t), $ = (n) => {
  const l = n % 4 === 0, a = n % 3 === 0, c = {
    options: {
      columnStart: n % 2 === 0 ? r.leftInner : r.auto,
      columnSpan: 2
    },
    mdOptions: {
      columnStart: n % 4 === 0 ? r.leftInner : r.auto,
      columnSpan: 1
    },
    lgOptions: {
      columnStart: a ? r.leftInner : r.auto,
      columnSpan: 12 / 3
    },
    xlOptions: {
      columnStart: l ? r.leftInner : r.auto,
      columnSpan: 12 / 4
    }
  }, m = {
    lgOptions: {
      columnStart: o.inner2,
      columnEnd: o.inner12
    }
  };
  return {
    logos12Col: c,
    logos10Col: m
  };
}, j = (n, t) => t || (n === "white" ? "neutral 100" : "white"), K = (n, t) => {
  const e = n === "12 column", l = ["xs", "sm", "md"].includes(t);
  return e || l;
}, U = (n) => ["xs", "sm", "md"].includes(n), H = ({
  item: n,
  classNameGen: t,
  componentName: e,
  logoThemeClassName: l
}) => {
  const a = d(
    `${t.getElementClassName("imageWrap")}-${l}`,
    {
      [t.getElementClassName("imgWrapWithoutLink")]: !n.imageLink
    }
  );
  return /* @__PURE__ */ s(
    I,
    {
      imageAltText: n.imageAltText,
      baseImage: n.baseImage,
      imageLink: n.imageLink,
      target: n.target,
      analyticsCompName: e,
      loading: "lazy",
      dimensions: { minHeight: "auto", minWidth: "auto" },
      className: a,
      maxSrcSetWidth: 601,
      isAnimated: !1,
      roundedCorners: !1
    },
    n.imageAltText
  );
}, M = ({
  item: n,
  classNameGen: t,
  componentName: e,
  logoThemeClassName: l
}) => /* @__PURE__ */ x(C, { children: [
  n.caption && /* @__PURE__ */ s(
    O,
    {
      className: t.getElementClassName("captionWrap"),
      as: "p",
      size: "Caption",
      children: n.caption
    }
  ),
  /* @__PURE__ */ s(
    H,
    {
      item: n,
      classNameGen: t,
      componentName: e,
      logoThemeClassName: l
    }
  )
] }), Z = ({
  logos: n,
  gridTheme: t,
  classNameGen: e,
  componentName: l,
  theme: a,
  logoCardTheme: c
}) => {
  const m = j(a, c), g = P.getThemeClassName(m), u = () => n.map((p, i) => {
    const S = A(t) ? v(i) : $(i);
    return /* @__PURE__ */ s(
      T,
      {
        className: e.getElementClassName("item"),
        ...S.logos12Col,
        children: /* @__PURE__ */ s(
          M,
          {
            item: p,
            classNameGen: e,
            componentName: l,
            logoThemeClassName: g
          }
        )
      },
      `${p.imageAltText}-${i + 1}`
    );
  });
  return n != null && n.length ? /* @__PURE__ */ s(C, { children: u() }) : null;
}, z = ({ children: n, className: t, ...e }) => {
  const {
    body: { backgroundColor: l }
  } = w(), { style: a, aboutToExit: c } = y(), m = {
    ...a,
    transform: "none"
  }, g = c ? { ...m, backgroundColor: l } : { backgroundColor: l }, u = h(null), p = N(u), i = d(t, p), { scrollYProgress: S } = R({ target: u });
  return L(S, "change", (f) => {
    f === 0 && l.set("#fff");
  }), /* @__PURE__ */ s(b.div, { style: g, className: i, ref: u, ...e, children: n });
}, X = ({
  children: n,
  ...t
}) => /* @__PURE__ */ s("div", { ...t, children: n }), V = ({
  disableSectionTransitions: n = !1,
  children: t,
  ...e
}) => n ? /* @__PURE__ */ s(X, { ...e, children: t }) : /* @__PURE__ */ s(E, { children: /* @__PURE__ */ s(z, { ...e, children: t }) });
export {
  V as D,
  M as L,
  $ as a,
  J as b,
  Z as c,
  U as d,
  j as g,
  A as i,
  K as s
};
//# sourceMappingURL=DocumentBody-0ce19478.js.map
